module.exports = __webpack_public_path__ + "img/download_stp.c427b123.svg";